export const videoContentTypes = [
    {
        label: 'All',
        value: 'All',
        urlId: 'All',
    },
    {
        label: 'Footage',
        value: 'Footage',
        urlId: 'Footage',
    },
    {
        label: 'Backgrounds',
        value: 'Backgrounds',
        urlId: 'Backgrounds',
    },
    {
        label: 'Templates',
        value: 'Templates',
        urlId: 'Templates',
    },
];

export const qualities = [
    {
        label: 'HD',
        value: 'HD',
        urlId: 'HD',
    },
    {
        label: '4K',
        value: '4K',
        urlId: '4K',
    },
];

export const frameRates = [
    {
        label: '23.98 / 24',
        value: 'fps24',
        urlId: 'fps24',
    },
    {
        label: '25',
        value: 'fps25',
        urlId: 'fps25',
    },
    {
        label: '29.97 / 30',
        value: 'fps30',
        urlId: 'fps30',
    },
    {
        label: '50',
        value: 'fps50',
        urlId: 'fps50',
    },
    {
        label: '59.94 / 60',
        value: 'fps60',
        urlId: 'fps60',
    },
];

export const mediaDetails = [
    {
        label: 'Model Released',
        value: 'talentReleased',
        urlId: 'model-released',
    },
    {
        label: 'Property Released',
        value: 'propertyReleased',
        urlId: 'property-released',
    },
];

export const templateTypes = [
    {
        label: 'All Templates',
        value: '',
        urlId: 'all-templates',
    },
    {
        label: 'After Effects',
        value: '89653',
        urlId: 'after-effects',
    },
    {
        label: 'Premiere Pro',
        value: '51',
        urlId: 'premiere-pro',
    },
    {
        label: 'DaVinci Resolve',
        value: '89673',
        urlId: 'davinci-resolve',
    },
    {
        label: 'Apple Motion',
        value: '19',
        urlId: 'apple-motion',
    },
];

export const footageCategories = [
    { label: 'All Categories', value: '', urlId: 'all-categories' },
    { label: '360° and VR', value: '23', urlId: '360-and-vr' },
    { label: 'Aerial', value: '1', urlId: 'aerial' },
    { label: 'Animals', value: '2', urlId: 'animals' },
    { label: 'Business and Professions', value: '4', urlId: 'business-and-professions' },
    { label: 'Effects and Lower Thirds', value: '20', urlId: 'effects-and-lower-thirds' },
    { label: 'Food and Beverage', value: '5', urlId: 'food-and-beverage' },
    { label: 'Green Screen', value: '24', urlId: 'green-screen' },
    { label: 'Historical and Archival', value: '6', urlId: 'historical-and-archival' },
    { label: 'Holidays and Celebrations', value: '7', urlId: 'holidays-and-celebrations' },
    { label: 'Lifestyle', value: '89666', urlId: 'lifestyle' },
    { label: 'Medical', value: '89665', urlId: 'medical' },
    { label: 'Nature', value: '9', urlId: 'nature' },
    { label: 'People', value: '10', urlId: 'people' },
    { label: 'Places and Landmarks', value: '22', urlId: 'places-and-landmarks' },
    { label: 'Slow Motion', value: '11', urlId: 'slow-motion' },
    { label: 'Sports and Recreation', value: '12', urlId: 'sports-and-recreation' },
    { label: 'Technology', value: '13', urlId: 'technology' },
    { label: 'Time Lapse', value: '14', urlId: 'time-lapse' },
    { label: 'Transportation', value: '15', urlId: 'transportation' },
];

export const templatesCategories = [
    { label: 'All Categories', value: '', urlId: 'all-categories' },
    { label: 'Business', value: '26', urlId: 'business' },
    { label: 'Cinematic', value: '31', urlId: 'cinematic' },
    { label: 'Intro', value: '25', urlId: 'intro' },
    { label: 'Logo Reveal', value: '27', urlId: 'logo-reveal' },
    { label: 'Photo', value: '33', urlId: 'photo' },
    { label: 'Presentation', value: '29', urlId: 'presentation' },
    { label: 'Promo', value: '34', urlId: 'promo' },
    { label: 'Slideshow', value: '30', urlId: 'slideshow' },
    { label: 'Titles', value: '32', urlId: 'titles' },
    { label: 'Typography', value: '28', urlId: 'typography' },
];

export const motionBackgroundsCategories = [
    { label: 'All Categories', value: '', urlId: 'all-categories' },
    { label: 'Abstract', value: '35', urlId: 'abstract' },
    { label: 'Business', value: '89667', urlId: 'business' },
    { label: 'Celebrations', value: '89672', urlId: 'celebrations' },
    { label: 'Colors', value: '89668', urlId: 'colors' },
    { label: 'Countdown', value: '44', urlId: 'countdown' },
    { label: 'Effects and Overlays', value: '89669', urlId: 'effects-and-overlays' },
    { label: 'Energy', value: '40', urlId: 'energy' },
    { label: 'Fire', value: '38', urlId: 'fire' },
    { label: 'Flowers', value: '39', urlId: 'flowers' },
    { label: 'Love', value: '43', urlId: 'love' },
    { label: 'Medical', value: '45', urlId: 'medical' },
    { label: 'Music', value: '47', urlId: 'music' },
    { label: 'Nature', value: '89670', urlId: 'nature' },
    { label: 'News', value: '89671', urlId: 'news' },
    { label: 'Particles', value: '41', urlId: 'particles' },
    { label: 'Religion', value: '49', urlId: 'religion' },
    { label: 'Science', value: '46', urlId: 'science' },
    { label: 'Shapes', value: '50', urlId: 'shapes' },
    { label: 'Space', value: '37', urlId: 'space' },
    { label: 'Technology', value: '48', urlId: 'technology' },
    { label: 'Water', value: '42', urlId: 'water' },
];

export const premiereProTemplateTypeId = '51';
export const appleMotionTemplateTypeId = '19';
export const daVinciResolveTemplateTypeId = '89673';
export const templatesContentTypeLabel = 'templates';
